import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
 * Activate Locked User Component
 */
let LockedUserActivationComponent = class LockedUserActivationComponent {
    constructor(httpClient, route, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.route = route;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.errorColor = '';
        this.successColor = '';
        this.linkColor = '';
        this.resendEmailError = false;
        this.resendEmailMessage = '';
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
        });
    }
    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.httpClient.get('unlockuser/' + params['hash']).subscribe((result) => {
                this.statusMessage = result['message'];
            }, (error) => {
                this.statusMessage = error.error['message'];
            });
        });
    }
    resendEmail() {
        this.resendEmailMessage = '';
        this.resendEmailError = false;
        this.route.params.subscribe((params) => {
            this.httpClient.get('unlockuser/' + params['hash'] + '/resend').subscribe((success) => {
                this.resendEmailMessage = success['message'];
            }, (error) => {
                this.resendEmailError = true;
                this.resendEmailMessage = error.error['message'];
            });
        });
    }
};
LockedUserActivationComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
LockedUserActivationComponent = __decorate([
    Component({
        selector: 'ecd-locked-user-activation',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./locked-user-activation.component.html")).default
    })
], LockedUserActivationComponent);
export { LockedUserActivationComponent };
